import React from "react";
import { useSelector } from "react-redux";
import { Switch } from "@mui/material";
import { selectDesiredEarMode } from "../../store/audioSettingsSlice";
import { AudioMessage_EarMode } from '../../generated/audio_message';
import microphoneIcon from "../../assets/microphone.svg";
import microphoneSlashIcon from "../../assets/microphone-slash.svg";
import "../../styles/components/useroverlay/MicModeToggle.css";

export type MicModeToggleVariant = 'switch' | 'button';

interface Props {
  onChange: (checked: boolean) => void;
  variant: MicModeToggleVariant;
}

const MicModeToggle: React.FC<Props> = ({
  onChange,
  variant,
}) => {
  const earMode = useSelector(selectDesiredEarMode);
  const micIsLive = earMode === AudioMessage_EarMode.CONVERSATION;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  const handleButtonClick = () => {
    // Toggle to the opposite state
    onChange(!micIsLive);
  };

  if (variant === 'switch') {
    return (
      <div className={`mic-mode-toggle-container`}>
        <Switch
          checked={micIsLive}
          onChange={handleChange}
          className="mic-mode-toggle"
          size="medium"
          disableRipple
        />
        <span className="mic-mode-toggle-label">Live Mic</span>
      </div>
    );
  }

  if (variant === 'button') {
    // Show the icon for the mode we can switch TO
    // If currently live-mic, show slash icon (switch to PTT)
    // If currently PTT, show normal mic icon (switch to live-mic)
    const iconToShow = micIsLive ? microphoneSlashIcon : microphoneIcon;
    const title = micIsLive ? "Switch to Push-to-Talk" : "Switch to Live Mic";

    return (
      <button
        className="mic-mode-toggle-button"
        onClick={handleButtonClick}
        title={title}
        aria-label={title}
      >
        <img src={iconToShow} alt={title} className="mic-mode-icon" />
      </button>
    );
  }

  return null;
};

export default MicModeToggle;
